module.exports = __webpack_public_path__ + "static/media/riffrMockup@3x.1feaf0b5.png";